import { Injectable } from '@angular/core';
import { ICompanyDTO, ICompanyNameIdLegalFormDTO } from '@modeso/types__aumico-lib-companies-be';

@Injectable({ providedIn: 'root' })
export class CompanyMapper {
    public mapCompanyDtoToCompanyNameIdLegalForm(company: ICompanyDTO): ICompanyNameIdLegalFormDTO {
        return {
            _id: company._id,
            name: company.name,
            legalform: company.legalform,
        };
    }
}
